/*
 * 热榜 API 统一入口
 */
import { fetchWeiboHot } from './weibo'
import { fetchBilibiliHot } from './bilibili'
import { fetchZhihuHot } from './zhihu'
import { fetchBaiduHot } from './baidu'
import { fetchToutiaoHot } from './toutiao'
import { fetch36krHot } from './36kr'
import { fetchHuxiuHot } from './huxiu'
import { fetchThepaperHot } from './thepaper'
import { fetchIthomeHot } from './ithome'
import { fetchDouyinHot } from './douyin'
import { fetchHupuHot } from './hupu'
import { fetchWoshipmHot } from './woshipm'

export {
  fetchWeiboHot,
  fetchBilibiliHot,
  fetchZhihuHot,
  fetchBaiduHot,
  fetchToutiaoHot,
  fetch36krHot,
  fetchHuxiuHot,
  fetchThepaperHot,
  fetchIthomeHot,
  fetchDouyinHot,
  fetchHupuHot,
  fetchWoshipmHot,
}

export { PLATFORM_API_MAP, PLATFORM_LIST, PLATFORM_NEWSNOW_ID } from './config'

// 平台到 API 函数的映射
export const PLATFORM_FETCHERS = {
  weibo: fetchWeiboHot,
  bilibili: fetchBilibiliHot,
  zhihu: fetchZhihuHot,
  baidu: fetchBaiduHot,
  toutiao: fetchToutiaoHot,
  '36kr': fetch36krHot,
  huxiu: fetchHuxiuHot,
  thepaper: fetchThepaperHot,
  ithome: fetchIthomeHot,
  douyin: fetchDouyinHot,
  hupu: fetchHupuHot,
  woshipm: fetchWoshipmHot,
}
